// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, updatePasswordProfessional } from "../../Utils/Constants";
import { toast } from "react-toastify";

export const hitUpdatePasswordProfessionalApi = createAsyncThunk("hitUpdatePasswordProfessionalApi", async (payload) => {
  try {
    const config = {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: `${localStorage.getItem("professionalToken")}`,
      },
    };
    const url = ApiBaseUrl + updatePasswordProfessional;
    const response = await axios.put(url, payload, config);
    return response.data;
  } catch (error) {
    toast.error(error.response.data.message);
    throw error.response.data;
  }
});

const UpdatePasswordProfessionalSlice = createSlice({
  name: "updatePasswordProfessionalReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitUpdatePasswordProfessionalData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitUpdatePasswordProfessionalApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitUpdatePasswordProfessionalApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitUpdatePasswordProfessionalApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitUpdatePasswordProfessionalData } = UpdatePasswordProfessionalSlice.actions;
export default UpdatePasswordProfessionalSlice.reducer;
